/* eslint-disable  react-hooks/exhaustive-deps */
/* eslint-disable  import/order */
import { Typography } from 'antd';
import React, { FC, useEffect, useLayoutEffect } from 'react';
import styled from 'styled-components';
import ShareholdersMultiple from '~/components/views/ShareholdersMultiple';
import ShareholdersSoleProprietor from '~/components/views/ShareholdersSoleProprietor';
import theme from '~/constants/theme';
import { useGetApplication, useSelectStep } from '~/controllers/wizard';
import { useRefScrollTo } from '~/hooks/useRefScrollTo';
import { getStagePayload } from '~/utils/getStagePayload';
import { isSales } from '~/utils/getDecodedJwt';

const Shareholders: FC = () => {
  const ref = useRefScrollTo();
  const applicationQuery = useGetApplication();
  const stagePayload = getStagePayload.wizard(applicationQuery.data);
  const activeStep = stagePayload?.activeStep;

  return (
    <Container ref={ref}>
      <Typography.Title>{activeStep?.stepName}</Typography.Title>
      {activeStep?.view === 'soleProprietorShareholders' ? (
        <ShareholdersSoleProprietor />
      ) : activeStep?.view === 'multipleShareholders' ? (
        <ShareholdersMultiple />
      ) : null}
    </Container>
  );
};

const Container = styled.div`
  h4 {
    margin-bottom: 24px;
  }
  section {
    margin-top: 48px;
  }
  @media (max-width: ${theme.breakpoints.md}px) {
    section {
      margin-top: 24px;
    }
  }
`;

export default Shareholders;
